import React from 'react';
import classnames from 'classnames';
// import Sticky from '@wix/da-ds/pkg/Sticky';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
// deviation_gruser TODO: this should be set up in UP project
// import cssVars from '@wix/da-ds/src/styles/variables.scss';
// import profilesCssVars from '../../../../styles/variables.scss';
import s from './WidgetHeaderMobile.scss';
const WidgetHeaderMobile = ({ className, isSticky, header, count, extras, extrasWhenSticky, rootClassName, isWide = false })=>{
    // T42244: The sticky headers get stuck a pixel too low sometimes
    // const marginTop =
    //   parseInt(cssVars['site-header-height-mobile']) +
    //   parseInt(profilesCssVars['mobile-navbar-height']) -
    //   1;
    const shouldRenderAsHeading = !!header;
    const Tag = shouldRenderAsHeading ? Heading : 'div';
    const renderInner = (isStuck = false)=>/*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], isStuck && s['is-stuck'], isWide && s['is-wide'], rootClassName)
        }, /*#__PURE__*/ React.createElement(Tag, {
            className: s['header'],
            "data-hook": BiDataHook.WIDGET_HEADER
        }, header, !!count && /*#__PURE__*/ React.createElement("span", {
            className: s['count'],
            "data-hook": BiDataHook.WIDGET_HEADER_COUNTER
        }, shortenNumber(count))), extras, isStuck && extrasWhenSticky);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['wrapper'], className)
    }, renderInner());
};
WidgetHeaderMobile.displayName = 'WidgetHeaderMobile';
export default WidgetHeaderMobile;
